import { takeEvery, call, select, put, delay } from 'redux-saga/effects';

export function watchEventChannel(channel, listeners) {
  return takeEvery(channel, function*({ eventName, args }) {
    if (listeners[eventName]) {
      yield call(listeners[eventName], args);
    }
  });
}

export function* dispatchActionIfSelectorHasValue(
  action,
  selector,
  conditionValue,
  maxTries = 10,
  suspendTimeout = 10
) {
  let value;
  let suspend = false;
  let tries = 0;
  do {
    if (suspend) {
      yield delay(suspendTimeout);
    } else {
      suspend = true;
    }
    value = yield select(selector);
    console.log('Value', value);
  } while (value !== conditionValue && tries++ < maxTries);
  if (value === conditionValue) {
    yield put(action);
  }
}
